import { render, staticRenderFns } from "./CompanyChange.vue?vue&type=template&id=4da240c8&scoped=true&"
import script from "./CompanyChange.vue?vue&type=script&lang=js&"
export * from "./CompanyChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da240c8",
  null
  
)

export default component.exports